var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-icon-calendar"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1899",
    "data-name": "Rectangle 1899",
    width: 23,
    height: 23,
    transform: "translate(0 0.001)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21563",
    "data-name": "Group 21563",
    transform: "translate(0.497 0.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21562",
    "data-name": "Group 21562",
    transform: "translate(-0.497 -0.629)",
    clipPath: "url(#clip-path-icon-calendar)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11090",
    "data-name": "Path 11090",
    d: "M130.453,180.906h.453a.453.453,0,0,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-123.908 -171.498)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11091",
    "data-name": "Path 11091",
    d: "M200.453,180.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-190.736 -171.498)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11092",
    "data-name": "Path 11092",
    d: "M270.453,180.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-257.564 -171.498)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11093",
    "data-name": "Path 11093",
    d: "M340.453,180.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-324.393 -171.498)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11094",
    "data-name": "Path 11094",
    d: "M410.453,180.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-391.221 -171.498)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11095",
    "data-name": "Path 11095",
    d: "M60.453,240.906h.453a.453.453,0,0,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-57.079 -228.779)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11096",
    "data-name": "Path 11096",
    d: "M130.453,240.906h.453a.453.453,0,0,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-123.908 -228.779)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11097",
    "data-name": "Path 11097",
    d: "M200.453,240.906h.453a.453.453,0,0,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-190.736 -228.779)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11098",
    "data-name": "Path 11098",
    d: "M270.453,240.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-257.564 -228.779)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11099",
    "data-name": "Path 11099",
    d: "M340.453,240.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-324.393 -228.779)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11100",
    "data-name": "Path 11100",
    d: "M410.453,240.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-391.221 -228.779)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11101",
    "data-name": "Path 11101",
    d: "M60.453,300.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-57.079 -286.061)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11102",
    "data-name": "Path 11102",
    d: "M130.453,300.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-123.908 -286.061)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11103",
    "data-name": "Path 11103",
    d: "M200.453,300.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-190.736 -286.061)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11104",
    "data-name": "Path 11104",
    d: "M270.453,300.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-257.564 -286.061)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11105",
    "data-name": "Path 11105",
    d: "M340.453,300.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-324.393 -286.061)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11106",
    "data-name": "Path 11106",
    d: "M410.453,300.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-391.221 -286.061)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11107",
    "data-name": "Path 11107",
    d: "M60.453,360.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-57.079 -343.342)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11108",
    "data-name": "Path 11108",
    d: "M130.453,360.906h.453a.453.453,0,0,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-123.908 -343.342)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11109",
    "data-name": "Path 11109",
    d: "M200.453,360.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-190.736 -343.342)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11110",
    "data-name": "Path 11110",
    d: "M270.453,360.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-257.564 -343.342)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11111",
    "data-name": "Path 11111",
    d: "M340.453,360.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-324.393 -343.342)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11112",
    "data-name": "Path 11112",
    d: "M410.453,360.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,0,0,0,.906",
    transform: "translate(-391.221 -343.342)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11113",
    "data-name": "Path 11113",
    d: "M60.453,420.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-57.079 -400.624)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11114",
    "data-name": "Path 11114",
    d: "M130.453,420.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-123.908 -400.624)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11115",
    "data-name": "Path 11115",
    d: "M200.453,420.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-190.736 -400.624)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11116",
    "data-name": "Path 11116",
    d: "M270.453,420.906h.453a.453.453,0,1,0,0-.906h-.453a.453.453,0,1,0,0,.906",
    transform: "translate(-257.564 -400.624)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11117",
    "data-name": "Path 11117",
    d: "M22.2,1.812H19.936V1.586a1.586,1.586,0,1,0-3.172,0v.227H5.89V1.586a1.586,1.586,0,0,0-3.172,0v.227H.453A.453.453,0,0,0,0,2.265V22.2a.453.453,0,0,0,.453.453H22.2a.453.453,0,0,0,.453-.453V2.265a.453.453,0,0,0-.453-.453M17.67,1.586a.68.68,0,1,1,1.359,0V2.945a.68.68,0,1,1-1.359,0V1.586Zm-14.046,0a.68.68,0,0,1,1.359,0V2.945a.68.68,0,0,1-1.359,0V1.586ZM.906,2.719H2.719v.227a1.586,1.586,0,0,0,3.172,0V2.719H16.764v.227a1.586,1.586,0,1,0,3.172,0V2.719h1.812V5.437H.906Zm20.842,19.03H.906V6.343H21.748Z",
    transform: "translate(0.202 0.347)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.a880f754952746cb4261e6219cffa242.svg";
export { ForwardRef as ReactComponent };